/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-foreign-prop-types */

const config = {
  name: 'Surfaces',
  id: 'SURFACES',
  children: [],
};

export default config;
